import axios from '@/service/request';
import apiConfig from '../apiConfig';

const baseUrl = apiConfig.movieApiDomain;

// 今日推荐
export const getRecommend = params => axios.get(`${baseUrl}/video/getRecommend`, { params: { ...params } });

// 最新电影
export const getNewestVideo = params => axios.get(`${baseUrl}/video/getNewest`, { params: { ...params } });

// 热门电影
export const getHot = params => axios.get(`${baseUrl}/video/getHot`, { params: { ...params } });

// 电影好评/差评
export const likeOrUnlike = params => axios.post(`${baseUrl}/video/getPraise`, params);

// 播放次数
export const addPlayNumber = params => axios.post(`${baseUrl}/video/addPlayNumber`, params);

// 电影收藏/取消收藏
export const addCollect = params => axios.post(`${baseUrl}/video/addCollect`, params);

// 电影详情
export const getVideoInfo = params => axios.get(`${baseUrl}/video/getInfo`, { params: { ...params } });

// 添加电影评论
export const addLongVideoComment = params => axios.post(`${baseUrl}/video/addComment`, params);

// 删除自己的电影评论
export const delLongVideoComment = params => axios.get(`${baseUrl}/video/delComment`, { params: { ...params } });

// 评论列表
export const getLongVideoComment = params => axios.get(`${baseUrl}/video/getComment`, { params: { ...params } });

// 子评论列表
export const getLongVideoCommentReply = params => axios.get(`${baseUrl}/video/getReply`, { params: { ...params } });

// 电影分类
export const getClass = params => axios.get(`${baseUrl}/video/getClass`, { params: { ...params } });

// 电影列表
export const getVideoList = params => axios.get(`${baseUrl}/video/getList`, { params: { ...params } });

// 为你推荐
export const getYouRecommend = params => axios.get(`${baseUrl}/video/getYouRecommend`, { params: { ...params } });

// 首页分类
export const getHomeClass = params => axios.get(`${baseUrl}/video/getHomeClass`, { params: { ...params } });

// 分类电影列表
export const getHomeList = params => axios.get(`${baseUrl}/video/getHomeList`, { params: { ...params } });

// 影片分享
export const videoShare = params => axios.post(`${baseUrl}/video/video_share`, params);

// 搜索页侧边栏数据
export const getLabelList = params => axios.get(`${baseUrl}/video/getLabelList`, { params: { ...params } });

// 搜索一级页数据
export const getSearchHome = params => axios.get(`${baseUrl}/video/getSearchHome`, { params: { ...params } });

// 公告列表
export const getNotice = params => axios.get('/public/getScroll', { params: { ...params } });

// banner-海报列表
export const getAdvertise = params => axios.get('/public/getAdvertise', { params: { ...params } });
